<template>
  <div>
    <template v-if="mode == 'new'">
      <div
        class="flex flex-c-c flex-c"
        style="width:100px;font-weight:400;border-radius:16px;
            color:#fff;
            height:32px;
            background:linear-gradient(0deg,rgba(30,191,145,1),rgba(49,203,158,1));
            border:1px solid rgba(42,199,153,1);"
        @click="triggerDialog"
      >{{ $t("lang.预约") }}</div>
    </template>
    <template v-else>
      <el-button :disabled="isInvite" type="primary" @click="triggerDialog">{{ $t("lang.预约视频会议") }}</el-button>
    </template>

    <el-dialog
      :title="$t('lang.发起预约')"
      :visible="dialogVisible"
      @close="dialogVisible = false"
      :width="isDesMobile ? '90%' : '50%'"
    >
      <div>
        <el-form
          ref="form"
          :model="form"
          :class="{ 'm-el-form': isDesMobile }"
          :label-position="g.isEn ? 'top' : 'left'"
          :label-width="isDesMobile ? '0' : '100px'"
        >
          <el-form-item
            :label="$t('lang.预约主题')"
            prop="top"
            :rules="[{ required: true, message: this.$t('lang.不能为空') }]"
          >
            <el-input v-model="form.top" size="default"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('lang.日期')"
            prop="activityTime"
            :rules="[{ required: true, message: this.$t('lang.不能为空') }]"
          >
            <el-date-picker
              size="default"
              :picker-options="expireTimeOption"
              type="date"
              :placeholder="$t('lang.选择日期')"
              v-model="form.activityTime"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            :label="$t('lang.会议时间')"
            prop="range"
            :rules="[{ required: true, message: this.$t('lang.不能为空') }]"
          >
            <el-time-picker
              format="HH:mm"
              is-range
              size="default"
              v-model="form.range"
              class="w100"
              :range-separator="$t('lang.到')"
              :start-placeholder="$t('lang.开始时间')"
              :end-placeholder="$t('lang.结束时间')"
            ></el-time-picker>
          </el-form-item>
          <el-form-item :label="$t('lang.发起预约弹窗留言')">
            <el-input type="textarea" v-model="form.remark" :maxLength="230"></el-input>
          </el-form-item>
          <el-form-item v-if="user.user2src == '1'" prop="contactId" :rules="[{ required: true, message: this.$t('lang.请选择联系人') }]" :label="$t('lang.联系人')">
            <el-select id="label_1" v-model="form.contactId" clearable>
              <el-option
                v-for="(item, index) in selectContactOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >{{ item.label }}</el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">
          {{
          $t("lang.取消")
          }}
        </el-button>
        <el-button type="primary" :loading="loading" @click="sure('form')">{{ $t("lang.确定") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bus from '@common/bus'
import { createProp } from "@common/utils";
import { timeToBjTime, timeToLocalTime } from '@common/utils/zoneMoment'
import ajax from "@common/utils/ajax";
import messageStoreMixin from "@match/store/message/messageStoreMixin";
import {
  appointment_type_message,
  appointment_type_message_china,
  personage_system_group,
  type_src_purchaser,
  type_src_supplier
} from "@common/constact";
import { getProjectId } from "@common/utils";
import myalert from "@common/utils/myalert";
import { mapGetters } from "vuex";
import findComponentUpward from "@common/utils/vueFindComponent/findComponentUpward";
import { getQuery } from "@common/utils/routerUtil";
import {
  createMessagePayload,
  createVideoWxPayload,
  sendMessage,
  sendMessageToGroup
} from "@common/utils/imUtils.js";
import { getNickName } from "@common/utils";
import { getLoginUser } from "@common/utils";
import loginCommon from "@match/components/login/loginDialog";
import { getUserIdByInfoAndType } from "../../common/utils";
import {go2RegisterForm, isComplateUserProfile} from "../utils";
import * as routerUtil from "../../common/utils/routerUtil";

export default {
  mixins: [messageStoreMixin],
  created() {
    this.rules = {
      top: [
        {
          required: true,
          message: this.lang == "zh" ? "请输入预约主题" : "topic is required",
          trigger: "blur"
        }
      ],
      activityTime: [
        {
          required: true,
          message:
            this.lang == "zh" ? "请选择日期" : "activity date is required",
          trigger: "change"
        }
      ],
      range: [
        {
          required: true,
          message:
            this.lang == "zh" ? "请选择时间" : "meeting time is required",
          trigger: "change"
        }
      ]
    };
  },
  data() {
    return {
      user: getLoginUser(),
      range: "",
      isInvite: false,
      loading: false,
      dialogVisible: false,
      form: {
        range: "",
        startTime: "",
        top: "",
        remark: "",
        activityTime: moment(new Date()).format("YYYY-MM-DD"),
        contactId: ""
      },
      loginVisible: false,
      rules: [],
      selectContactOptions: [],
      expireTimeOption: {
        disabledDate(date) {
          return (
            moment(date.getTime())
              .add(1, "day")
              .valueOf() <= Date.now()
          );
        }
      }
    };
  },
  props: {
    userId: createProp([String, Number]),
    info: createProp([Object]),
    online: createProp([String, Number], {
      default: 0
    }),
    mode: createProp([String, Number])
  },
  mounted() {
   },
  components: {
    loginCommon
  },
  computed: {
    ...mapGetters("mobile", ["isDesMobile"]),
    endTime() {
      if (!this.form.startTime) return "";
      var time =
        moment(this.form.activityTime).format("YYYY-MM-DD") +
        " " +
        this.form.startTime +
        ":00";
      return moment(moment(new Date(time)).add(15, "m")).format("HH:mm");
    }
  },
  methods: {
    async ajaxContactOptions() {
      // selectContactOptions
      // GET /api3/suppliercontact/{supplierId}/getAllSupplierContact
      // http://localhost:8081/api/api3/suppliercontact/df7970f9-7ffe-4cc3-b04d-b0567800941f/getAllSupplierContact?current=1&size=3
      var toId = getUserIdByInfoAndType(this.info);
      var result = await ajax
        .get(`/api3/suppliercontact/${toId}/getAllSupplierContact?current=1&size=9999`)
        .then(res => res.data);
      console.log(result.result, "yanyue");
      this.selectContactOptions =
        result.result &&
        result.result.list &&
        result.result.list.map(item => {
          return {
            value: item.id,
            label: item.name
          };
        });
    },
    triggerDialog() {
      var user = getLoginUser();
      //没有登录跳转登录
        if (user.id == null || user.id == undefined || user.id == '') {
          myalert.confirm("您未登录，请先登录再操作").then(isyes => {
            if (isyes) {
              routerUtil.push("/login")
              bus.$emit('getonbus',true)
              return false
            }
          })

          return false
        }
      if (user.id == null || user.id == undefined || user.id == "") {
        this.loginVisible = !this.loginVisible;
        return false;
      } else {
        if (!isComplateUserProfile()) {
          myalert.fail(
            this.$t("lang.您还没有完善个人信息，请填写完毕后在操作")
          );
          setTimeout(() => {
            go2RegisterForm()
          }, 500);
          return false;
        }
        this.ajaxContactOptions();
        this.dialogVisible = true;
      }
    },
    sure(refName) {
      let self = this;
      var user = getLoginUser();
      
      if (user.id == null || user.id == undefined || user.id == "") {
        self.loginVisible = !self.loginVisible;
        return false;
      }
      var parent = findComponentUpward(this, "liveExhibitionDetail");
      this.$refs["form"].validate(async isyes => {
        if (isyes) {
          var usertype = user.user2src;
          this.loading = true;
          console.log(this.form)
          const activityStart = timeToBjTime(moment(this.form.activityTime).format('YYYY-MM-DD') +
            " " +
            moment(this.form.range[0]).format("HH:mm:ss"), 'dateAll')
          const activityEnd = timeToBjTime(moment(this.form.activityTime).format('YYYY-MM-DD') +
            " " +
            moment(this.form.range[1]).format("HH:mm:ss"), 'dateAll')
          const activityTime = timeToBjTime(moment(this.form.activityTime).format('YYYY-MM-DD') +
            " " +
            moment(this.form.range[0]).format("HH:mm:ss"), 'date')
          if (usertype == type_src_supplier) {
            var toId = getUserIdByInfoAndType(this.info);
            var params = {
              remark: "string",
              sponsor: getLoginUser().user2src,
              ...this.form,
              projectId: getProjectId(),
              supplierId: user.id,
              purchaserId: toId,
              // activityTime: moment(this.form.activityTime).format("YYYY-MM-DD"),
              // activityStart: moment(this.form.range[0]).format("HH:mm:ss"),
              // activityEnd: moment(this.form.range[1]).format("HH:mm:ss"),
              activityTime: activityTime,
              activityStart: activityStart,
              activityEnd: activityEnd,
              companyId: user.companyId,
              [parent ? "liveId" : ""]: getQuery("liveId"),
             contactId: user.contactId
            };

            delete params.range;
            delete params.timeInterval;
            delete params.startTime;
            await ajax.post(`/api3/schedule/addSupplierSchedule`, params);
            this.loading = false;
            this.dialogVisible = false;
            myalert.success(`${this.$t("lang.邀约发送成功")}`);
            this.form = {
              startTime: "",
              top: "",
              remark: "",
              activityTime: ""
            };
            this.$refs[refName] &&
              this.$refs[refName].resetFields &&
              this.$refs[refName].resetFields();
            var text = getNickName();
            var url = `/user/yiwu/reservation`; //TODO:预约路径加入状态
            /*     await sendMessageToGroup(
                       createMessagePayload(
                           url,
                           `${text}向你发起了邀约`,
                           appointment_type_message.invite),
                       personage_system_group + this.userId
                   )*/
            return false;
          }

          if (usertype == type_src_purchaser) {
            var toId = getUserIdByInfoAndType(this.info);


            var params = {
              remark: "string",
              sponsor: getLoginUser().user2src,
              ...this.form,
              purchaserId: user.id,
              supplierId: toId,
              projectId: getProjectId(),
              // activityTime: moment(this.form.activityTime).format("YYYY-MM-DD"),
              // activityStart: moment(this.form.range[0]).format("HH:mm:ss"),
              // activityEnd: moment(this.form.range[1]).format("HH:mm:ss"),
              activityTime: activityTime,
              activityStart: activityStart,
              activityEnd: activityEnd,
              companyId: user.companyId,
              [parent ? "liveId" : ""]: getQuery("liveId")
            };
            delete params.timeInterval;
            delete params.range;
            await ajax.post(`/api3/schedule/addPurchaserSchedule`, params);
            this.loading = false;
            this.dialogVisible = false;
            this.form = {
              startTime: "",
              top: "",
              remark: "",
              activityTime: ""
            };
            this.$refs[refName] &&
              this.$refs[refName].resetFields &&
              this.$refs[refName].resetFields();
            var text = getNickName();
            var url = `/user/yiwu/reservation`; //TODO:预约路径加入状态
            myalert.success(`${this.$t("lang.邀约发送成功")}`);
            return false;
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.w100 {
  width: 100% !important;
}

.m-el-form {
  /deep/ .el-form-item--mini.el-form-item,
  /deep/ .el-form-item--small.el-form-item {
    margin: 0 0 10px;
  }

  /deep/ .el-form-item--small .el-form-item__content,
  /deep/ .el-form-item--small .el-form-item__label {
    line-height: 25px;
    padding: 0 0 3px;
  }
}

.isEnglish {
  width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/wenxing/components/inviteButton.vue